import { Autocomplete, Box, TextField } from "@mui/material";
import { countries, countryToFlag, findCountryByPhoneCode } from "./countries";
import React from "react";
export function PhonePrefixSelect({ label, value, onChange }) {
    return (React.createElement(Autocomplete, { multiple: false, value: findCountryByPhoneCode(value), onChange: (_, country) => onChange((country === null || country === void 0 ? void 0 : country.phone) || null), options: countries, autoHighlight: true, getOptionLabel: (option) => `${countryToFlag(option.code)} ${option.code} (+${option.phone})`, renderOption: (props, option) => (React.createElement("li", Object.assign({}, props),
            React.createElement(Box, { sx: {
                    display: "inline-block",
                    fontSize: "1.25em",
                    marginRight: 1,
                } }, countryToFlag(option.code)),
            React.createElement("span", null,
                option.label,
                " (",
                option.code,
                ") +",
                option.phone))), renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { variant: "outlined", label: label, inputProps: Object.assign(Object.assign({}, params.inputProps), { autoComplete: "new-password" }) }))) }));
}
//# sourceMappingURL=phone-prefix-select.js.map